selected ediOrdersId: {{ ediOrdersId.join(', ') }}
